import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Component, ...rest }) => {
  // Check if user is authenticated (e.g., check sessionStorage for a token)
  const token = localStorage.getItem('token');  // Or however you store the token
  console.log(token);
  return token ? <Component {...rest} /> : <Navigate to="/" />;
};

export default PrivateRoute;
